import { Power1 } from 'gsap';
import Preset from '../Preset';
import Rectangle from '../../graphics/Rectangle';

export default class Shutter extends Preset {
  topOverlay = new Rectangle();
  bottomOverlay = new Rectangle();

  constructor(app) {
    super({ app, isFullScreen: true });
  }

  update(model) {
    super.update(model);

    const { x, y, width, height } = this.root;
    const halfDuration = model.duration / 2;

    this.topOverlay.color = this.primaryColor.clone();
    this.topOverlay.alpha = 0;
    this.topOverlay.width = width;
    this.topOverlay.height = 0;
    this.topOverlay.y = y;
    this.topOverlay.x = x;

    this.animate(this.topOverlay)
      .to({
        alpha: this.primaryColor.getAlpha(),
        height: height / 2,
        duration: halfDuration,
        ease: Power1.easeInOut,
      })
      .reverseOut();

    this.bottomOverlay.color = this.primaryColor.clone();
    this.bottomOverlay.alpha = 0;
    this.bottomOverlay.width = width;
    this.bottomOverlay.height = 0;
    this.bottomOverlay.y = y + height;
    this.bottomOverlay.x = x;

    this.animate(this.bottomOverlay)
      .to({
        alpha: this.primaryColor.getAlpha(),
        y: y + height / 2,
        height: height / 2,
        duration: halfDuration,
        ease: Power1.easeInOut,
      })
      .reverseOut();
  }

  render() {
    super.render();
    this.topOverlay.draw(this.graphics);
    this.bottomOverlay.draw(this.graphics);
  }
}
